import React from "react";

const WidgetColumn = ({ children, className, condition }) =>
  !condition ? null : (
    <div className={`widget-column ${className || ""}`}>{children}</div>
  );
export default WidgetColumn;
